
import type { RewardPool } from '@shared/api/types/rewardPools';

import { type DialogProps } from '@radix-ui/react-dialog';
import { RewardOptions } from '@store:web/components/entities/rewardPool';
import { CustomDialog } from '@ui/uikit/components/common/Dialog';

interface Props extends DialogProps {
  rewardPool: RewardPool;
}

export const EntryOptionsDialog = ({ rewardPool, ...props }: Props) => {
  return (
    <CustomDialog
      size="lg"
      title="Raffle Entry Options"
      titleIsLeftAligned
      noBottomPadding
      {...props}
    >
      <RewardOptions
        showHeader={false}
        showFooter={false}
        rewardPool={rewardPool}
        hasBorders={false}
      />
    </CustomDialog>
  );
};
